export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-6">
              实时追踪 · 独家揭秘
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              51电影网
              <br className="md:hidden" />
              <span className="text-primary-500"> — </span>
              <span className="text-foreground-800">全方位影视追踪与独家幕后揭秘</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading font-medium mb-6">
              票房黑马、争议事件、明星动态，一站掌握影视圈每一个精彩瞬间
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[620px] mx-auto lg:mx-0 mb-8">
              51电影网是国内领先的影视娱乐资讯聚合平台，覆盖电影上映排期、
              幕后花絮揭秘、明星动态追踪、票房数据分析与争议事件深度报道。
              每日更新海量独家内容，从院线新片到流媒体热播，从行业八卦到深度影评，
              为影迷提供一站式影视资讯体验。当前聚焦暑期档票房争夺战与各大电影节前线直击。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">200+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新资讯</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">独家幕后揭秘</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">7×24</div>
                <div className="text-xs text-foreground-500 mt-1">全天候追踪报道</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                探索独家揭秘
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-secondary-300 text-secondary-700 font-semibold text-sm rounded-lg hover:bg-secondary-100 hover:border-secondary-400 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                查看热门榜单
                <i className="ri-fire-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20film%20reel%2C%20director%20chair%2C%20spotlight%2C%20red%20velvet%20curtain%2C%20clapperboard%2C%20golden%20trophy%2C%20warm%20theater%20lighting%2C%20artistic%20minimalist%20composition%2C%20dark%20rich%20background%20with%20warm%20gold%20and%20crimson%20accents%2C%20editorial%20photography%20style%2C%20elegant%20and%20sophisticated&width=1040&height=1300&seq=hero-main-visual&orientation=portrait"
                alt="51电影网 - 全方位影视追踪与独家幕后揭秘主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}